import Icon from '../../../components/AppIcon';

const ServicesGrid = () => {
  const services = [
    {
      id: 1,
      icon: "AlertTriangle",
      title: "Emergency Fault Finding",
      description: "Rapid diagnosis and repair of electrical faults causing power outages, tripping circuits, or safety hazards. Available 24/7 for urgent situations.",
      features: ["Circuit breaker issues", "Power outages", "Electrical shorts", "Safety hazards"],
      color: "var(--color-error)"
    },
    {
      id: 2,
      icon: "Activity",
      title: "Electrical Diagnostics",
      description: "Comprehensive testing and analysis using professional equipment to identify hidden electrical problems before they become emergencies.",
      features: ["Load testing", "Voltage analysis", "Wiring inspection", "Safety audits"],
      color: "var(--color-accent)"
    },
    {
      id: 3,
      icon: "Wrench",
      title: "Repairs & Maintenance",
      description: "Expert repair services for all electrical systems including outlets, switches, lighting, and appliances with quality parts and workmanship.",
      features: ["Outlet repairs", "Switch replacement", "Light fixtures", "Appliance wiring"],
      color: "var(--color-primary)"
    },
    {
      id: 4,
      icon: "Home",
      title: "Residential Installations",
      description: "Complete electrical installations for new homes, renovations, and upgrades including lighting, power points, and safety systems.",
      features: ["New installations", "Home rewiring", "Lighting design", "Smart home setup"],
      color: "var(--color-secondary)"
    },
    {
      id: 5,
      icon: "Building2",
      title: "Commercial Solutions",
      description: "Specialized electrical services for businesses including restaurants, retail spaces, and offices with minimal disruption to operations.",
      features: ["Commercial wiring", "Three-phase power", "Emergency lighting", "Compliance testing"],
      color: "var(--color-success)"
    },
    {
      id: 6,
      icon: "Shield",
      title: "Safety Inspections",
      description: "Thorough electrical safety inspections and compliance certificates for property sales and peace of mind.",
      features: ["COC certificates", "Safety testing", "Code compliance", "Risk assessment"],
      color: "var(--color-warning)"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="font-headline font-bold text-2xl md:text-3xl lg:text-4xl text-foreground mb-4">
            Comprehensive Electrical Services
          </h2>
          <p className="font-body text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            From emergency repairs to complete installations, we provide expert electrical solutions backed by 30+ years of experience and unwavering commitment to safety.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services?.map((service) => (
            <div
              key={service?.id}
              className="bg-card border border-border rounded-xl p-6 md:p-8 hover:shadow-elevated transition-all duration-300 group"
            >
              <div
                className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-xl mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-300"
                style={{ backgroundColor: `${service?.color}15` }}
              >
                <Icon name={service?.icon} size={24} color={service?.color} />
              </div>

              <h3 className="font-headline font-semibold text-lg md:text-xl text-foreground mb-3">
                {service?.title}
              </h3>

              <p className="font-body text-sm md:text-base text-muted-foreground mb-4 md:mb-6">
                {service?.description}
              </p>

              <ul className="space-y-2">
                {service?.features?.map((feature, index) => (
                  <li key={index} className="flex items-center gap-2 font-body text-sm text-foreground">
                    <Icon name="Check" size={16} color="var(--color-success)" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;